import script from "./ProfilRisqueResultModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilRisqueResultModal.vue?vue&type=script&setup=true&lang=js"

import "./ProfilRisqueResultModal.vue?vue&type=style&index=0&id=33720e90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33720e90"]])

export default __exports__